import api from "./api";

export default {
  createFakeEventBucket(apiKey, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `god/create_fake_event_bucket`,
          json: options,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  autoCreate(apiKey, options) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `god/auto_create`,
          json: options,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchStats(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `god/stats`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchRevenue(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `god/revenue`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchUpcomingEvents(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `god/upcoming_events`,
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  becomePerson(apiKey, person) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `god/become_person`,
          json: { person: person },
          api_key: apiKey
        },
        (err, response) => {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/GodUtil.js